var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Graph")]),_c('div',[_c('line-chart',{ref:"myChart",attrs:{"data":_vm.chartList,"messages":{empty: 'Loading data'},"refresh":20}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }